// extracted by mini-css-extract-plugin
export default {"container":"contact_container__r9rmr","content":"contact_content__Q0nI3","avatar":"contact_avatar__1RBQo","info":"contact_info__WpxZ-","description":"contact_description__p2eqg"};